<script lang="ts">
	import { Verbiage, t } from '@infinitro/content';
	import { SupportIcon } from '@infinitro/icons';

	export let onOpen: () => void = () => {};
</script>

<button class="widget-launcher" type="button" aria-label={$t(Verbiage.support)} on:click={onOpen}>
	<span class="widget-launcher-icon" aria-hidden="true">
		<SupportIcon />
	</span>
</button>

<style>
	.widget-launcher {
		position: fixed;
		bottom: 1.5rem;
		right: 1.5rem;
		z-index: 1200;
		display: flex;
		height: 4rem;
		width: 4rem;
		align-items: center;
		justify-content: center;
		border-radius: 9999px;
		color: var(--color-text-100);
		background-image: var(--gradient-secondary);
		box-shadow:
			0 12px 28px rgba(var(--color-background-900-rgb), 0.28),
			0 0 0 4px rgba(var(--color-text-100-rgb), 0.12)
}

	.widget-launcher-icon {
		display: block;
		height: 1.75rem;
		width: 1.75rem
}

	.widget-launcher-icon :global(svg),
	.widget-launcher-icon :global(img) {
		height: 100%;
		width: 100%
}
</style>
